module.exports = __webpack_public_path__ + "img/prize-04-icon.080a8da9.png";